<template><!-- svgo-optimised -->
<svg class="icon icon__pause" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle opacity="0.5" cx="10" cy="10" r="10" fill="white" stroke-width="0" />
  <path d="M7.77777 6.66669V13.3334" stroke="white"/>
  <path d="M12.2222 6.66669V13.3334" stroke="white"/>
</svg>

</template>